export default (theme) => {
  return {
    container: {
      height: 107.34,
      flexDirection: 'inherit',
    },
  }
}
